import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/of';
import { EmployeeAsset } from '../../models/employee-asset.model';
import { OffboardingReturnClothing } from '../../models/offboarding.model';
import { ClothingTypeReturnRequest } from '../../models/clothing-disposition.model';
import { OffboardingService } from '../../services/offboarding.service';
import { EmployeeAssetsService } from '../../services/employee-assets.service';
import { ClothingDispositionService } from '../../services/clothing-disposition.service';
import { ASSET } from '../common/employee-assets/asset.constants';

export const RETURN_MODE = {assets: 'ASSETS', clothing: 'CLOTHING'};
export interface ReturnRow {id: string; name: string; asset?: EmployeeAsset; unit?: OffboardingReturnClothing;}
export interface ReturnPage {items: ReturnRow[]; hasMore: boolean;}
export interface ClothingReturnBatch {catalogItemId: string; request: ClothingTypeReturnRequest;}
@Injectable()
export class OffboardingReturnGateway {
  constructor(private assets: EmployeeAssetsService, private offboarding: OffboardingService, private clothing: ClothingDispositionService) {}
  list(employeeId: string, page: number, mode: string): Observable<ReturnPage> {
    if (mode === RETURN_MODE.clothing) {
      return this.clothingPage(employeeId, page);
    }
    return this.assets.list({employeeId: employeeId, page: page, view: ASSET.all}).map(result => ({hasMore: result.hasMore,
      items: result.items.filter(asset => (asset.kind === ASSET.service || asset.remainingQuantity > ASSET.zero)
        && asset.allowedActions.indexOf(asset.kind === ASSET.service ? ASSET.revokeAccess : ASSET.returnAction) >= ASSET.zero)
        .map(asset => ({id: asset.id, name: asset.name, asset: asset}))}));
  }
  returnClothing(employeeId: string, batch: ClothingReturnBatch): Observable<Object> {
    return this.clothing.returnType(employeeId, batch.catalogItemId, batch.request);
  }
  private clothingPage(employeeId: string, page: number): Observable<ReturnPage> {
    return this.offboarding.returnClothing(employeeId, page).mergeMap(result => {
      const items: ReturnRow[] = result.items.map(unit => ({id: unit.unitId, name: unit.catalogItemName, unit: unit}));
      if (!result.hasMore) { return Observable.of({items: items, hasMore: false}); }
      return this.clothingPage(employeeId, page + ASSET.one)
        .map(next => ({items: items.concat(next.items), hasMore: false}));
    });
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/offboarding/offboarding-return.gateway.ts